// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-components-LibkeyNomadMigration-LibkeyNomadMigration-module__banner";
export { _1 as "banner" }
